/**
 * Public "interstitial" routes the gateway 303-redirects the browser to when the signed-in identity
 * cannot proceed into the app on this host:
 *
 * - `/session-conflict` — the identity belongs to a different tenant / the cluster plane (PTV2-1383).
 * - `/identity-not-linked` — the external identity authenticated but isn't linked to any user; the
 *   gateway captured it PENDING for an admin to link (PTV2-1448, capture-then-link).
 *
 * These pages are rendered ABOVE the auth gate by {@link SessionGuard} (the viewer has no app session
 * here) and are **terminal**: the `/me` probe still fires from the auth provider, but its 401 must NOT
 * trigger the {@link handleUnauthorized} redirect to `/login` — otherwise an authenticated-but-unlinked
 * identity loops (`/me` 401 → `/login` → re-auth via the live IdP SSO session → capture → back here).
 * The only way on from an interstitial is the page's own action (sign out / sign in elsewhere).
 */
export const SESSION_CONFLICT_PATH = '/session-conflict';

export const IDENTITY_NOT_LINKED_PATH = '/identity-not-linked';

/** Whether the given pathname is one of the terminal interstitial routes. */
export function isInterstitialPath(pathname: string): boolean {
  return pathname.endsWith(SESSION_CONFLICT_PATH) || pathname.endsWith(IDENTITY_NOT_LINKED_PATH);
}
